import NavMenu from "./components/NavMenu";
import HeroBanner from "./components/HeroBanner";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Products from "./components/Products";
import Bandera from "./components/Bandera";
import Team from "./components/Team";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <NavMenu />
      <main>
        <HeroBanner />
        <Marquee />
        <About />
        <Products />
        <Bandera />
        <Team />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
